import { render, staticRenderFns } from "./TransfiyaBancaria.vue?vue&type=template&id=59839b69&scoped=true"
import script from "./TransfiyaBancaria.vue?vue&type=script&lang=js"
export * from "./TransfiyaBancaria.vue?vue&type=script&lang=js"
import style0 from "./TransfiyaBancaria.vue?vue&type=style&index=0&id=59839b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59839b69",
  null
  
)

export default component.exports